export default class CounterSpinner extends HTMLDivElement {

    connectedCallback() {

        this.reset();

        if (!this.intersectionObserverSupported) {
            this.startCount(this, this.dataset.from, this.dataset.to);
            return;
        }

        const options = {
            threshold: 1
        };

        const observer = new IntersectionObserver(this.handleIntersect, options);

        observer.observe(this);
    }

    handleIntersect = (entries, observer) => {

        for (let i = 0; i < entries.length; i++) {
            const entry = entries[i];
            const element = entry.target;
            if (entry.isIntersecting) {
                this.startCount();
            }
        }

    }

    startCount() {

        if (this.hasCounted) {
            return;
        }

        this.hasCounted = true;

        this.animateValue(this.from, this.to, 1000);
    }

    animateValue = (start, end, duration) => {
        let startTimestamp = null;

        const step = (timestamp) => {
            if (!startTimestamp) startTimestamp = timestamp;
            const progress = Math.min((timestamp - startTimestamp) / duration, 1);
            this.innerHTML = this.formatNumber(Math.floor(progress * (end - start) + start));
            if (progress < 1) {
                window.requestAnimationFrame(step);
            }
        };

        window.requestAnimationFrame(step);
    }

    formatNumber(value) {
        return value.toLocaleString("sv-SE");
    }

    reset() {
        this.hasCounted = false;
        this.innerText = this.dataset.from;
    }

    get hasCounted() {
        return this.dataset.hasCounted === "true";
    }

    set hasCounted(value) {
        this.dataset.hasCounted = value;
    }

    get from() {
        return Number(this.dataset.from);
    }

    get to() {
        return Number(this.dataset.to);
    }

    get intersectionObserverSupported() {
        return "IntersectionObserver" in window;
    }
}

customElements.define("counter-spinner", CounterSpinner, { extends: "div" });